import React from 'react';
import Home from './Home';
import HomeLayout from '../../components/Layout/HomeLayout';
import { getListingFields } from '../../actions/getListingFields'

import { setPersonalizedValues } from '../../actions/personalized';
import fetch from '../../core/fetch';
import { convert } from '../../helpers/currencyConvertion';

export default async function action({ store }) {
  const title = store.getState().siteSettings.data.siteTitle;
  const description = store.getState().siteSettings.data.metaDescription;
  const listingFields = store.getState().listingFields.data;
  const layoutType = store.getState().siteSettings.data.homePageType;
  const wholeData = store.getState().homeBannerImages.data;

  if (listingFields === undefined) await store.dispatch(getListingFields());

  await store.dispatch(setPersonalizedValues({ name: 'personCapacity', value: null }));

  const locationsResponse = await fetch('/graphql', {
    method: 'post',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: '{ stays: getSearchLocations(listingType: "accommodation") { country state city } experiences: getSearchLocations(listingType: "experience") { country state city } }' }),
    credentials: 'include',
  });
  const locationsPayload = await locationsResponse.json();
  const searchLocations = locationsPayload.data || { stays: [], experiences: [] };

  const fields = `id title city state coverPhoto reviewsCount reviewsStarRating
    listPhotos { id name } listingData { basePrice currency }`;
  const experiencesResponse = await fetch('/graphql', {
    method: 'post',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: `{
      experiences: SearchListing(listingType: "experience", country: "CO", currentPage: 1) { results { ${fields} } }
      stays: SearchListing(listingType: "accommodation", country: "CO", currentPage: 1) { results { ${fields} } }
    }` }),
    credentials: 'include',
  });
  const experiencesPayload = await experiencesResponse.json();
  const catalog = experiencesPayload.data || {};
  const currency = store.getState().currency;
  const mapListing = (item, isExperience) => {
    const photos = item.listPhotos || [];
    const selectedPhoto = photos.find(photo => photo.id === item.coverPhoto) || photos[0];
    let price = item.listingData && Number(item.listingData.basePrice);
    const sourceCurrency = item.listingData && item.listingData.currency;
    if (price && sourceCurrency && sourceCurrency !== 'COP') {
      price = currency.rates && currency.rates[sourceCurrency] && currency.rates.COP
        ? convert(currency.base, currency.rates, price, sourceCurrency, 'COP') : null;
    }
    const reviewCount = Number(item.reviewsCount) || 0;
    return {
      id: `${isExperience ? 'experience' : 'stay'}-${item.id}`,
      state: item.state || '',
      place: [item.city, item.state].filter(Boolean).join(', ') || 'Colombia rural',
      detail: item.title || (isExperience ? 'Experiencia rural' : 'Alojamiento rural'),
      price: price ? `Desde $${Math.round(price).toLocaleString('es-CO')} COP ${isExperience ? 'por persona' : 'por noche'}` : 'Consulta disponibilidad',
      rating: reviewCount && item.reviewsStarRating ? (item.reviewsStarRating / reviewCount).toLocaleString('es-CO', { maximumFractionDigits: 2 }) : 'Nueva',
      image: selectedPhoto ? `/images/upload/${selectedPhoto.name}` : null,
      badge: isExperience ? 'Experiencia aprobada' : 'Alojamiento aprobado',
      url: `/rooms/${item.id}`,
    };
  };
  const publishedExperiences = ((catalog.experiences && catalog.experiences.results) || []).map(item => mapListing(item, true));
  const publishedStays = ((catalog.stays && catalog.stays.results) || []).map(item => mapListing(item, false));

  return {
    title,
    description,
    listingFields,
    component:
      <HomeLayout
        layoutType={layoutType}
      >
        <Home layoutType={layoutType} wholeData={wholeData} searchLocations={searchLocations} publishedExperiences={publishedExperiences} publishedStays={publishedStays} />
      </HomeLayout>
  };
}
